import { gql } from "@apollo/client";
import Stack from "atoms/Stack";
import { COLOR_WHITE } from "helpers/colors";
import { FONT_FAMILY_ROBOTO } from "helpers/FONT";
import { gaEvent } from "helpers/gtag";
import useActionFragment from "helpers/useActionFragment";
import useData from "helpers/useData";
import RatingStars from "pages/potw/RatingStars";
import React from "react";

export const VideoEventPotwRatingFragment = gql`
  fragment VideoEventPotwRatingFragment on Game {
    id
    livePotwCompetition {
      id
      competitionType
    }
  }
`;

export default function VideoEventPotwRating({ game, eventId, mobileEventStream = false }) {
  const [data] = useData(
    gql`
      query VideoEventPotwRating($eventId: ID!) {
        event(id: $eventId) {
          id
          type
          livePotwEntry {
            id
            currentUserRating
          }
          potwEntriesAny
        }
      }
    `,
    { eventId },
  );

  const livePotwCompetition = game?.livePotwCompetition;

  const eventPotwRate = useActionFragment("eventPotwRate", "event { id livePotwEntry { id currentUserRating } }");

  if (
    [
      "BasketballFoul",
      "FutsalFoul",
      "MiniballFoul",
      "NetballFoul",
      "BasketballTurnover",
      "MiniballTurnover",
      "NetballTurnover",
      "Reaction",
    ].includes(data?.event.type)
  )
    return null;

  return (
    livePotwCompetition && (
      <Stack
        horizontal
        veryDense
        alignItemsCenter
        style={{
          fontSize: mobileEventStream ? 14 : 10,
          paddingTop: mobileEventStream ? 6 : 0,
          paddingRight: mobileEventStream ? 6 : 0,
        }}
      >
        <Stack veryDense>
          <div
            style={{
              color: COLOR_WHITE,
              fontFamily: FONT_FAMILY_ROBOTO,
            }}
          >
            Plays of the Week
          </div>
          <RatingStars
            currentRating={data?.event.livePotwEntry?.currentUserRating}
            onRate={(rating) => {
              gaEvent("potw_rate", {
                from: "video_page",
                rating,
              });
              eventPotwRate({ input: { eventId, rating } });
            }}
            style={{ fontSize: "1.5em" }}
          />
        </Stack>
      </Stack>
    )
  );
}
